import React from "react";

import { Wrapper } from "components/templates/MainTemplate/MainTemplate.styles";
import { Title } from "components/atoms/Title/Title";
import Navigation from "components/organisms/Navigation/Navigation";
import { Paragraph } from "views/Step4.styles";
import GlobalData from "data/GlobalData";

const MainTemplate = ({ children, step, setStep, lang }) => {
  return (
    <Wrapper>
      <Title>{lang === "pl" ? GlobalData.title.pl : GlobalData.title.en}</Title>
      <Paragraph>
        {lang === "pl" ? GlobalData.subtitle.pl : GlobalData.subtitle.en}
      </Paragraph>
      <Navigation
        GlobalData={GlobalData}
        lang={lang}
        step={step}
        setStep={setStep}
      />
      {children}
    </Wrapper>
  );
};

export default MainTemplate;
